import axios from 'axios';
import { createStore } from "vuex";

export default createStore({
  state: {
    status: '',
    user: {},
    isLoading:false,
    val:'',
    toggle:true,
    filterText:'' ,
    dotsLoading:false,
    scrollValue:0
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading'
    },
    auth_success(state, user) {
      state.status = 'success'
      state.user = user
    },
    auth_error(state) {
      state.status = 'error'
    },
    logout(state) {
      state.status = ''
    },
    setDotsLoading(state, newValue) {
      state.dotsLoading = newValue;
    },
    scroll_done(state, newValue){
      state.scrollValue = newValue
    }
  },
  actions: {
    getUserInfo({ commit }) {
      commit('auth_request')
      return new Promise((resolve, reject) => {
        axios({
          url: `${process.env.VUE_APP_AUTH_API_URL}/userInfo/get`,
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('AUTH_ID')
          }
        })
        .then(resp => {
          const user = resp.data[0];
          user.currentRole = user.roles.find((role:any) => { return role.appId == 10002 }).roleId
          commit('auth_success', user)
          resolve(resp)
        })
        .catch(err => {
            commit('auth_error');
            reject(err);
            localStorage.removeItem('AUTH_ID');
            // window.location.href = window.location.origin+'/monitor/onboarding'
            // window.location.href = 'http://localhost:8080'
            // window.location.href = "https://auth.vuedirect.com/?returnTo=https://dms.vuedirect.com"; 
            window.location.href = `${process.env.VUE_APP_AUTH_WEBAPP_URL}/session?returnTo=${process.env.VUE_APP_DMS_WEBAPP_URL}`; 

        })
      })
    },
    logout({ commit }) {
      return new Promise<void>((resolve) => {
        commit('logout');
        resolve();
      })
    },
    selectedRoute(context, payload) {
      context.state.val=payload
     },
     selectedToggle(context, payload) {
      context.state.toggle=payload
     },
     updateDotsLoading({ commit }, newValue) {
      commit('setDotsLoading', newValue);
    },
    scrollDone({ commit }, newValue) {
      commit('scroll_done', newValue);
    },
  },
  getters: {
    authStatus: state => state.status,
    userInfo: state => state.user,
    loading:state=>state.isLoading,
    val:state=>state.val,
    toggle:state=>state.toggle,
    dotsLoading:state=>state.dotsLoading,
    scrollDoneValue:state => state.scrollValue
  }
});